import React from "react";
import { Lightbulb, ShieldCheck, Users, TrendingUp, Target, Zap, Award } from "lucide-react";

export default function AboutUs() {
  return (
    <div className="about-us-page">

      {/* 2️⃣ Brightest Minds Section */}
      <section className="brightest-section">
        <div className="brightest-container">
          {/* Left Text */}
          <div className="brightest-text">
            <h2>
              The Brightest Minds
              <br />in Digital at Your Service
            </h2>
            <p>
              We help brands connect with their customers by creating personal
              connections in this digital world. Most of them are still with us.
            </p>
          </div>

          {/* Right Image */}
          <div className="brightest-image">
          <img src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/mind.svg" alt="Brightest Minds" />
          </div>
        </div>
      </section>

      {/* 3️⃣ Our Core Values Section */}
      <section className="core-values-section">
        <div className="core-values-content">
          <h2>Our Core Values</h2>
          <p>
            At the heart of everything we do are <strong>Innovation</strong>,{" "}
            <strong>Integrity</strong>, and <strong>Collaboration</strong>. We
            constantly challenge what’s possible, creating smarter solutions
            through fresh ideas and creativity. Our foundation is built on
            honesty, respect, and transparency, guiding every decision we make.
            Together, we grow stronger — sharing every success and valuing every
            idea as part of our collective journey.
          </p>
        </div>
      </section>

{/* 5️⃣ Conferences Section - Simple Horizontal Layout */}
<section
  className="conference-section"
  style={{ background: "#121723", color: "#fff", padding: "120px 20px" }}
>
  <div
    className="conference-container"
    style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}
  >
    {/* Section Title */}
    <h2 style={{ fontSize: "42px", fontWeight: "800", marginBottom: "40px" }}>
      We Attend World-Class Conferences
    </h2>

    {/* Conference List */}
    <ul
      style={{
        listStyle: "none",
        padding: 0,
        marginBottom: "50px",
        fontSize: "18px",
        lineHeight: "1.8",
      }}
    >
      <li>Dubai Fintech Summit</li>
      <li>IFX Expo Dubai 2023 & 2024</li>
      <li>Seamless Middle East</li>
      <li>ICE Conference London</li>
    </ul>

    {/* Conference Images */}
    <div
      className="conference-images"
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "30px",
        flexWrap: "wrap",
      }}
    >
      <img
        src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/conf1.png"
        alt="Conference 1"
        style={{
          width: "220px",
          maxHeight: "220px",
          objectFit: "cover",
          borderRadius: "12px",
        }}
      />
      <img
        src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/conf2.png"
        alt="Conference 2"
        style={{
          width: "220px",
          maxHeight: "220px",
          objectFit: "cover",
          borderRadius: "12px",
        }}
      />
      <img
        src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/conf3.png"
        alt="Conference 3"
        style={{
          width: "220px",
          maxHeight: "220px",
          objectFit: "cover",
          borderRadius: "12px",
        }}
      />
      <img
        src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/conf4.png"
        alt="Conference 4"
        style={{
          width: "220px",
          maxHeight: "220px",
          objectFit: "cover",
          borderRadius: "12px",
        }}
      />
    </div>
  </div>
</section>
 

{/* 🌟 Featured In Section */}
<section className="featured-section">
  <div className="featured-container">
    
    {/* Left Text */}
    <div className="featured-left">
      <p className="featured-small-heading">We are featured in</p>
      <h2 className="featured-brand-name">Arius Business</h2>
    </div>

    {/* Right Text */}
    <div className="featured-right">
      <p>
        Reflex Advisor has been reviewed and featured on <strong>Arius Business</strong> —
        a trusted platform highlighting top-performing service providers. Clients and
        industry peers have recognized our work, validating our commitment to delivering
        real results for businesses across industries.
      </p>

      <a
        href="https://ariusbusiness.com/company/reflex-advisor"
        target="_blank"
        rel="noopener noreferrer"
        className="featured-review-btn"
      >
        Read Our Review →
      </a>

    </div>

  </div>
</section>

{/* 🏆 Awards Section */}
<section
  className="awards-section"
  style={{
    background: "#121723", // same as Brightest Minds section
    color: "#fff",
    padding: "80px 20px",
    textAlign: "center",
  }}
>
  <h2 className="awards-heading" style={{ fontSize: "40px", fontWeight: "700", marginBottom: "50px" }}>
    We’re the Award-Winning Agency
  </h2>

  <div className="awards-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "100px", flexWrap: "wrap" }}>
    {/* Card 1 */}
    <div className="award-card" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
      <img src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/clutchco.svg" alt="Clutch Logo" className="award-logo" style={{ width: "160px", height: "auto", marginBottom: "15px" }} />
      <p className="award-text" style={{ fontSize: "18px", color: "#e5e7eb", maxWidth: "260px", lineHeight: "1.5" }}>Best marketing agency for startups</p>
    </div>

    {/* Card 2 */}
    <div className="award-card" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
      <img src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/crunchbase.svg" alt="Crunchbase Logo" className="award-logo" style={{ width: "190px", height: "auto", marginBottom: "15px" }} />
      <p className="award-text" style={{ fontSize: "18px", color: "#e5e7eb", maxWidth: "260px", lineHeight: "1.5" }}>
        30 best Marketing agencies to increase sales in 2025
      </p>
    </div>
  </div>
</section>


{false && (  // <-- this prevents rendering
<section
  className="team-section"
  style={{
    backgroundColor: "#ffffff", // white background
  }}
>
  <div className="team-overlay">
    <h2 className="section-heading">Meet the Leadership</h2>
    <p className="section-subtext">
      The people who turn vision into meaningful progress.
    </p>

    <div
      className="team-grid"
      style={{ gridTemplateColumns: "repeat(4, 1fr)" }}
    >
      {/* Member 1 */}
      <div className="team-card">
        <div className="team-photo-wrap">
          <img
            src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/ceo.png"
            alt="Jessy Heineman"
            className="team-photo"
            style={{ borderRadius: "12px" }}
          />
        </div>
        <h3 className="team-name">Jessy Heineman</h3>
        <p className="team-role">Chief Executive Officer (CEO)</p>
      </div>

      {/* Member 2 */}
      <div className="team-card">
        <div className="team-photo-wrap">
          <img
            src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/michael.jpg"
            alt="Brian Harrison"
            className="team-photo"
            style={{ borderRadius: "12px" }}
          />
        </div>
        <h3 className="team-name">Brian Harrison</h3>
        <p className="team-role">Business Development Officer</p>
      </div>

      {/* Member 3 */}
      <div className="team-card">
        <div className="team-photo-wrap">
          <img
            src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/emily.jpg"
            alt="Emily Davis"
            className="team-photo"
            style={{ borderRadius: "12px" }}
          />
        </div>
        <h3 className="team-name">Emily Davis</h3>
        <p className="team-role">Creative Director</p>
      </div>

      {/* Member 4 */}
      <div className="team-card">
        <div className="team-photo-wrap">
          <img
            src="https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/Maddy.png"
            alt="Sara Jhonson"
            className="team-photo"
            style={{ borderRadius: "12px" }}
          />
        </div>
        <h3 className="team-name">Sara Jhonson</h3>
        <p className="team-role">Chief Marketing Officer</p>
      </div>
    </div>
  </div>
</section>
)}

      {/* Styles */}
      <style>{`

        .about-us-page {
          font-family: "Elza", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          background: #fff;
          color: #111;
        }

        /* 2️⃣ Brightest Minds Section */
        .brightest-section {
          background: #121723;
          color: #fff;
          padding: 120px 20px;
        }
        .brightest-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 60px;
          max-width: 1200px;
          margin: 0 auto;
          flex-wrap: wrap;
        }
        .brightest-text {
          flex: 1;
          min-width: 360px;
        }
        .brightest-text h2 {
          font-size: 52px;
          font-weight: 800;
          margin-bottom: 20px;
          line-height: 1.2;
        }
        .brightest-text p {
          font-size: 18px;
          color: #ddd;
          line-height: 1.7;
        }
        .brightest-image {
          flex: 1;
          min-width: 360px;
          display: flex;
          justify-content: center;
        }
        .brightest-image img {
          width: 100%;
          max-width: 500px;
          height: auto;
        }
        @media (max-width: 900px) {
          .brightest-container { flex-direction: column; text-align: center; }
          .brightest-image img { max-width: 400px; }
        }

        /* 3️⃣ Core Values Section (Black Background) */
        .core-values-section {
          background: #000;
          color: #fff;
          padding: 140px 20px;
          text-align: center;
        }
        .core-values-content {
          max-width: 900px;
          margin: 0 auto;
        }
        .core-values-content h2 {
          font-size: 52px;
          font-weight: 800;
          margin-bottom: 30px;
        }
        .core-values-content p {
          font-size: 18px;
          line-height: 1.8;
          color: #e7eaf6;
        }

        /* 🌟 Featured Section */
.featured-section {
  background: #7b19bc;
  color: #fff;
  padding: 60px 20px;
  font-family: "Elza", sans-serif;
}

.featured-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  max-width: 1100px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.featured-left {
  flex: 1;
  min-width: 300px;
  text-align: left;
}

.featured-small-heading {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-family: "Elza", sans-serif;
}

.featured-brand-name {
  font-size: 42px;
  font-weight: 800;
  color: #fff;
  margin: 0;
  line-height: 1.1;
  letter-spacing: -0.5px;
  font-family: "Elza", sans-serif;
}

.featured-right {
  flex: 1;
  min-width: 300px;
  font-size: 18px;
  color: #e5e7eb;
  line-height: 1.6;
  font-family: "Elza", sans-serif;
}

.featured-review-btn {
  display: inline-block;
  margin-top: 20px;
  padding: 11px 24px;
  background: #fff;
  color: #7b19bc;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  border-radius: 0px;
  letter-spacing: 0.5px;
  transition: background 0.25s ease, color 0.25s ease;
}

.featured-review-btn:hover {
  background: rgba(255, 255, 255, 0.85);
  color: #7b19bc;
}

@media (max-width: 900px) {
  .featured-container {
    flex-direction: column;
    text-align: center;
  }

  .featured-left,
  .featured-right {
    text-align: center;
  }

  .featured-brand-name {
    font-size: 32px;
  }

  .featured-small-heading {
    font-size: 12px;
  }

  .featured-right {
    font-size: 16px;
  }

  .featured-review-btn {
    width: 100%;
    text-align: center;
    box-sizing: border-box;
  }
}

/* 🏆 Awards Section */
.awards-section {
  background: #0000;
  color: #fff;
  text-align: center;
  padding: 80px 20px;
  font-family: "Elza", sans-serif;
}

.awards-heading {
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 50px;
}

.awards-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 100px; /* increased spacing between cards */
  flex-wrap: wrap;
}

.award-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: transparent; /* invisible card */
}

.award-logo {
  width: 160px;
  height: auto;
  margin-bottom: 15px;
}

/* Make Crunchbase logo slightly bigger */
.award-card:nth-child(2) .award-logo {
  width: 190px;
}

.award-text {
  font-size: 18px;
  color: #e5e7eb;
  max-width: 260px;
  line-height: 1.5;
}

@media (max-width: 900px) {
  .awards-heading {
    font-size: 32px;
  }

  .award-logo {
    width: 130px;
  }

  .award-card:nth-child(2) .award-logo {
    width: 160px;
  }

  .award-text {
    font-size: 16px;
  }

  .awards-container {
    gap: 60px; /* tighter spacing on mobile */
  }
}

/* 4️⃣ Team Section */
.team-section {
  position: relative;
  background: #ffffff; /* white background */
  color: #111;
  text-align: center;
  display: none; /* <-- add this line to hide the section */
}

/* Remove dark overlay effect */
.team-overlay {
  background: transparent;
  padding: 100px 20px;
}

/* Heading */
.team-overlay .section-heading {
  font-size: 48px;
  margin-bottom: 20px;
  color: #111;
}

/* Subtext */
.section-subtext {
  color: #666;
  font-size: 18px;
  margin-bottom: 60px;
  text-align: center;
}

/* Grid */
.team-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Card */
.team-card {
  text-align: center;
  transition: transform 0.3s ease;
}

.team-card:hover {
  transform: translateY(-6px);
}

/* Image Wrapper */
.team-photo-wrap {
  overflow: hidden;
  border-radius: 14px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12); /* softer shadow for white bg */
  width: 250px;
  height: 250px;
  margin: 0 auto;
  background: #f9f9f9;
}

/* Image */
.team-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  border-radius: 14px;
}

/* Text */
.team-name {
  font-size: 20px;
  font-weight: 700;
  margin-top: 14px;
  color: #111;
}

.team-role {
  font-size: 15px;
  color: #777;
  margin-top: 4px;
}

/* Responsive */
@media (max-width: 1024px) {
  .team-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .team-grid {
    grid-template-columns: 1fr;
  }
}
        
      `}</style>
    </div>
  );
}
